export default __webpack_public_path__ + "assets/img/ic-pages-left.248cc6debf346e61bf8946b1caad59e9.svg";